// Spegel av functions/src/utils/slug.ts — håll reglerna identiska.
export const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,58}[a-z0-9])?$/;

const PREFIXES = [
  'bostadsrättsföreningen', 'bostadsrättsförening', 'bostadsrattsforeningen', 'bostadsrattsforening',
  'hsb brf', 'riksbyggen brf', 'hsb', 'riksbyggen', 'brf.', 'brf',
];

const TRANSLITERATION = { å: 'a', ä: 'a', ö: 'o', é: 'e', è: 'e', ü: 'u', ø: 'o', æ: 'a' };

export function suggestAssociationSlug(name) {
  let s = (name || '').toLowerCase().trim().replace(/\s+/g, ' ');
  for (const prefix of PREFIXES) {
    if (s === prefix) { s = ''; break; }
    if (s.startsWith(prefix + ' ')) { s = s.slice(prefix.length).trim(); break; }
  }
  s = s.replace(/[åäöéèüøæ]/g, (c) => TRANSLITERATION[c] || c);
  s = s.replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  if (s.length > 60) s = s.slice(0, 60).replace(/-+$/, '');
  return s;
}

export function isValidSlug(slug) {
  return typeof slug === 'string' && SLUG_PATTERN.test(slug);
}

export const PUBLIC_SITE_URL = process.env.REACT_APP_PUBLIC_SITE_URL || 'https://hyria.se';

export function publicAssociationUrl(slug) {
  return slug ? `${PUBLIC_SITE_URL}/brf/${slug}` : '';
}

/**
 * Länken som den visas på föreningskortet — utan https://. Två föreningar kan
 * heta likadant (i dev finns två "Bostadsrättsföreningen Solhöjden"); länken är
 * då det enda som skiljer dem åt för den som testar en aktivering.
 */
export function publicAssociationLabel(slug) {
  return publicAssociationUrl(slug).replace(/^https?:\/\//, '');
}
